import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppAsideLink,
  ResidentAppAsideSection,
  ResidentAppAsideText,
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { ReservationCalendars } from '../ReservationCalendars'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'
import { ReservationsList } from '../../components/ReservationsList'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetReservationRulesAndTerms } from '../../api/apiHooks/useAPIGetReservationRulesAndTerms'

export const GymReservations: React.FC = () => {
  const { t, i18n } = useTranslation(['common', 'reservations', 'titles'])
  const moduleConfig = useModuleConfig()
  const { frontPagePath } = useContractPaths()
  const { currentContractId } = useCurrentContract()

  const { data: rulesAndTerms } = useAPIGetReservationRulesAndTerms(
    currentContractId,
    'gym',
    i18n.language,
    null
  )

  const moduleLinks: { href: string; label: string }[] = []
  const gymReservationsConfig = moduleConfig.gymReservations
  if (gymReservationsConfig?.contractDocumentLink) {
    moduleLinks.push({
      href: gymReservationsConfig.contractDocumentLink,
      label: t('reservations:modal.commonAreaRulesLink'),
    })
  }
  if (gymReservationsConfig?.termsOfUseDocumentLink) {
    moduleLinks.push({
      href: gymReservationsConfig.termsOfUseDocumentLink,
      label: t('reservations:modal.commonAreaTermsLink'),
    })
  }

  const dbLinksAll = rulesAndTerms
    ? [
        ...rulesAndTerms.files.map((file) => ({
          href: file.url,
          label: file.displayFileName,
        })),
        ...rulesAndTerms.externalLinks.map((link) => ({
          href: link.url,
          label: link.title,
        })),
      ]
    : []

  const infoLinks = dbLinksAll.length > 0 ? dbLinksAll : moduleLinks

  return (
    <TitleController title={t('titles:gymReservations', 'Gym reservations')}>
      <ResidentAppView
        title={t('reservations:pageTitleGym')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
        aside={
          <>
            <ResidentAppAsideSection>
              <ResidentAppAsideText>
                {t(
                  'reservations:gymSidebarDescription',
                  'Täällä voit tarkastella kuntosalivuoroja ja varata oman vuoron valitsemalla vapaan ajan'
                )}
              </ResidentAppAsideText>
              {infoLinks.map((link) => (
                <ResidentAppAsideLink key={link.href} href={link.href} external>
                  {link.label}
                </ResidentAppAsideLink>
              ))}
            </ResidentAppAsideSection>
            <ReservationsList reservableCategory="gym" />
          </>
        }
      >
        <ResidentAppCard>
          <ReservationCalendars reservableCategory="gym" />
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
